import React, { useRef } from "react";
import { useQuery } from "react-query";
import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import api from "api";

import Card from "./Card";
import CardSkeleton from "./CardSeleton";

const LatestCourse = () => {
  const swiperRef = useRef();
  const { data, isLoading } = useQuery({
    queryFn: api.course.getFeaturedCourse,
    queryKey: ["feature-course"],
  });

  return (
    <section className="pt-16 md:pt-20 md:pb-20 lg:pb-20 ">
      <div className="px-5 py-10 md:px-16 md:pt-16 max-w-7xl mx-auto">
        <div className="rounded-[13px]">
          <div className="text-center pb-6">
            <div className="flex w-full justify-center">
              <h2 className="text-[30px] leading-9 md:text-[40px] lg:text-5xl text-white text-center hind-siliguri">
                Join Our Upcoming Courses
              </h2>
            </div>
          </div>

          <div className="block md:hidden">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={10}
              slidesPerView={1}
              autoplay={{ delay: 3000 }}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
            >
              {isLoading
                ? Array.from({ length: 3 }).map((_, index) => (
                    <SwiperSlide key={index}>
                      <CardSkeleton />
                    </SwiperSlide>
                  ))
                : data?.map((item, index) => (
                    <SwiperSlide key={index}>
                      <Card item={item} />
                    </SwiperSlide>
                  ))}
            </Swiper>
          </div>

          <div className="hidden md:grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-5 pt-5 md:pt-10">
            {isLoading
              ? Array.from({ length: 3 }).map((_, index) => (
                  <CardSkeleton key={index} />
                ))
              : data?.map((item) => <Card key={item.id} item={item} />)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestCourse;
